import React from 'react'
import ReactDOM from 'react-dom'
import './styles/main.scss'
import App from './components/App'
import AppProps from './components/types/AppProps'
import data from './data'

if (document.getElementById('quiz-root') !== null) {
	ReactDOM.render(<App data={data} />, document.getElementById('quiz-root'));
}
